export interface Bonus {
  label: string
  title: string
  subtitle: string
  body: string
  value: string
}

export const bonuses: Bonus[] = [
  {
    label: '🎁 BONUS 1',
    title: 'GUIDE DES CODES DÉFAUT OBD-II : LECTURE ET PREMIÈRES VÉRIFICATIONS™',
    subtitle: 'Du code lu au contrôle juste, sans conclusion hâtive',
    body: 'Anatomie d’un code à cinq caractères, états présent, mémorisé ou intermittent, questions à poser avant de lire et premières vérifications sur le circuit concerné. Un code se lit comme une piste, jamais comme un verdict.',
    value: '15 €',
  },
  {
    label: '🎁 BONUS 2',
    title: 'GUIDE PRATIQUE DU MULTIMÈTRE ET DES MESURES ÉLECTRIQUES AUTOMOBILE™',
    subtitle: 'Mesurer juste, interpréter juste',
    body: 'Les fonctions utiles à l’atelier, la mesure de tension, de résistance et de continuité, la chute de tension sous charge et la recherche de consommation parasite, sur les circuits basse tension uniquement.',
    value: '15 €',
  },
  {
    label: '🎁 BONUS 3',
    title: 'FICHES ATELIER IMPRIMABLES : RÉCEPTION, DIAGNOSTIC ET CONTRÔLE QUALITÉ™',
    subtitle: 'Chaque intervention documentée, du premier contact au véhicule restitué',
    body: 'Fiche de réception, questionnaire symptôme client, fiche de diagnostic avec une zone par étape de la méthode, contrôle qualité et restitution : prêtes à imprimer ou à remplir sur tablette.',
    value: '15 €',
  },
  {
    label: '🎁 BONUS 4',
    title: 'GUIDE DES VOYANTS DU TABLEAU DE BORD : SIGNIFICATION ET CONDUITE À TENIR™',
    subtitle: 'Du voyant allumé au bon réflexe',
    body: 'Voyants rouges, orange, verts et bleus : ce que chaque témoin signale, s’il faut s’arrêter, rouler avec prudence ou programmer un contrôle, et par quoi commencer le diagnostic à l’atelier.',
    value: '15 €',
  },
  {
    label: '🎁 BONUS 5',
    title: 'CAHIER DE CAS PRATIQUES : 50 PANNES ANALYSÉES PAS À PAS™',
    subtitle: 'S’entraîner à raisonner comme un technicien de diagnostic',
    body: '50 cas fictifs à difficulté progressive, de la gestion moteur aux trains roulants, chacun construit sur SYMPTÔME › CODES › MESURES › HYPOTHÈSE › VALIDATION avec un corrigé détaillé.',
    value: '15 €',
  },
]
